import styled from '@emotion/styled'

const RelatedArticlesItemText = styled.p`
    font-size: 18px;
    font-style: normal;
    line-height: 145%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; 
    margin: 0; 
`

export default RelatedArticlesItemText